import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Mail, Lock, AlertCircle, ArrowRight
} from 'lucide-react';

const LoginForm = () => {
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const carouselData = [
    {
      title: "Connect with Alumni",
      description: "Join a vibrant community of graduates and expand your professional network",
      image: "https://d8it4huxumps7.cloudfront.net/uploads/images/65799bf7b8ae5_frame_1000013237.png?d=700x700"
    },
    {
      title: "Access Opportunities",
      description: "Discover exclusive job postings and career advancement opportunities",
      image: "https://firebasestorage.googleapis.com/v0/b/studymate-c44e8.appspot.com/o/alumnijob.png?alt=media&token=375481c5-c176-4293-bba8-a128b55c7fab"
    },
    {
      title: "Stay Updated",
      description: "Get the latest news and updates from your alma mater",
      image: "https://d8it4huxumps7.cloudfront.net/uploads/images/un-pro/upgrade-banner-image.png?d=813x639"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % carouselData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/auth/alumni/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }
      
      localStorage.setItem('token', data.token);
      localStorage.setItem('userRole', 'alumni');
      navigate('/profile');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden py-8">
      {/* Background SVG Pattern */}
      <div className="absolute inset-0 z-0" 
           style={{
             backgroundImage: "url('https://statics.myclickfunnels.com/image/301108/file/215e0050b0709c2f41a105beec3f25ff.svg')",
             backgroundSize: "600px",
             backgroundRepeat: "repeat",
             opacity: 0.15
           }} />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex justify-center mb-6">
          <img 
            src="https://i.ibb.co/Y2zGN8s/saarthilogo.png"
            alt="Saarthi Logo"
            className="h-12 w-auto"
          />
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row" style={{ minHeight: '600px' }}>
            {/* Left side - Carousel with wave background */}
            <div className="hidden md:block md:w-5/12 bg-[#ffc700] relative overflow-hidden">
              {/* Wave pattern background */}
              <div className="absolute inset-0 z-0 opacity-10"
                   style={{
                     backgroundImage: "url('https://d8it4huxumps7.cloudfront.net/uploads/images/login/border-vector-image.png?d=943x2825')",
                     backgroundSize: "cover",
                     backgroundPosition: "center",
                   }} />
              
              <div className="h-full flex flex-col justify-between relative z-10">
                {/* Carousel Section */}
                <div className="p-8 flex-grow">
                  <div className="h-full flex flex-col">
                    {carouselData.map((slide, index) => (
                      <div
                        key={index}
                        className={`transition-opacity duration-500 ${
                          index === activeSlide ? 'opacity-100' : 'opacity-0 hidden'
                        }`}
                      >
                        <div className="aspect-w-16 aspect-h-9 mb-4">
                          <img
                            src={slide.image}
                            alt={slide.title}
                            className="w-full h-72 object-cover rounded-lg"
                          />
                        </div>
                        <div className="mt-4 text-gray-900">
                          <h3 className="text-lg font-bold">{slide.title}</h3>
                          <p className="mt-2 text-sm text-gray-800">{slide.description}</p>
                        </div>
                        
                      </div>
                    ))}
                  </div>
                </div>

                {/* Footer Section with Links */}

<div className="bg-white/90 p-6  mt-auto border-t border-amber-100/50 shadow-lg">
  <div className="text-center space-y-4">
  
    
    <div className="pt-2 border-t border-amber-100">
      <p className="text-sm text-gray-600 mb-2">
        By signing in to Saarthi, you agree to our
      </p>
      <div className="flex justify-center items-center space-x-4 text-sm font-medium">
        <a 
          href="/terms" 
          className="text-amber-700 hover:text-amber-900 transition-colors hover:underline"
        >
          Terms
        </a>
        <div className="w-1 h-1 rounded-full bg-amber-300"></div>
        <a 
          href="/privacy" 
          className="text-amber-700 hover:text-amber-900 transition-colors hover:underline"
        >
          Privacy
        </a>
        <div className="w-1 h-1 rounded-full bg-amber-300"></div>
        <a 
          href="/community" 
          className="text-amber-700 hover:text-amber-900 transition-colors hover:underline"
        >
          Guidelines
        </a>
      </div>
    </div>
  </div>
</div>
              </div>
            </div>

            {/* Right side - Login Form */}
            <div className="w-full md:w-7/12 bg-white flex flex-col">
              <div className="p-6 md:p-8 flex-grow flex flex-col justify-center">
                <div className="max-w-md mx-auto w-full">
                <div className="mb-8">
  <div className="flex items-start space-x-2">
    <h2 className="text-2xl font-bold text-gray-900 mb-1">
      Welcome back to Saarthi!
      <span className="ml-2 inline-block animate-wave">👋</span>
    </h2>
  </div>
  
  <div className="space-y-3">
    <p className="text-sm text-gray-600">
      Sign in to your account to continue your journey
    </p>
    
    <div className="flex flex-wrap gap-2">
      <span className="inline-flex items-center px-2 py-1 rounded-full bg-amber-50 text-xs font-medium text-amber-700">
        <span className="mr-1">🎓</span> Alumni Network
      </span>
      <span className="inline-flex items-center px-2 py-1 rounded-full bg-blue-50 text-xs font-medium text-blue-700">
        <span className="mr-1">💼</span> Job Opportunities
      </span>
      <span className="inline-flex items-center px-2 py-1 rounded-full bg-green-50 text-xs font-medium text-green-700">
        <span className="mr-1">🤝</span> Mentorship
      </span>
    </div>
  </div>

  <style jsx>{`
    @keyframes wave {
      0% { transform: rotate(0deg); }
      20% { transform: rotate(-10deg); }
      40% { transform: rotate(10deg); }
      60% { transform: rotate(-10deg); }
      80% { transform: rotate(10deg); }
      100% { transform: rotate(0deg); }
    }
    .animate-wave {
      animation: wave 2s infinite;
      transform-origin: 70% 70%;
      display: inline-block;
    }
  `}</style>
</div>

                  <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                      <div className="p-3 text-sm text-red-800 rounded-lg bg-red-50 border border-red-100">
                        <div className="flex items-center">
                          <AlertCircle className="h-4 w-4 mr-2" />
                          {error}
                        </div>
                      </div>
                    )}

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email address
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <Mail className="h-4 w-4 text-amber-600" />
                        </div>
                        <input
                          type="email"
                          required
                          className="pl-9 w-full rounded-md border border-gray-300 bg-white py-2 text-sm text-gray-900 outline-none focus:border-amber-600 focus:ring-1 focus:ring-amber-600 transition-colors"
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Password
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <Lock className="h-4 w-4 text-amber-600" />
                        </div>
                        <input
                          type="password"
                          required
                          className="pl-9 w-full rounded-md border border-gray-300 bg-white py-2 text-sm text-gray-900 outline-none focus:border-amber-600 focus:ring-1 focus:ring-amber-600 transition-colors"
                          value={formData.password}
                          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        />
                      </div>
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <input
                          id="remember-me"
                          type="checkbox"
                          className="h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded"
                        />
                        <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                          Remember me
                        </label>
                      </div>
                      <a href="/forgot-password" className="text-sm font-medium text-amber-600 hover:text-amber-700">
                        Forgot password?
                      </a>
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full flex items-center justify-center py-2.5 px-4 rounded-lg text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:bg-amber-300 transition-colors duration-200"
                    >
                      {loading ? (
                        <div className="flex items-center space-x-2">
                          <div className="w-5 h-5 border-t-2 border-white border-solid rounded-full animate-spin" />
                          <span>Signing in...</span>
                        </div>
                      ) : (
                        <div className="flex items-center">
                          <span>Sign in</span>
                          <ArrowRight className="ml-2 h-4 w-4" />
                        </div>
                      )}
                    </button>
                    <div className="flex flex-col items-center justify-center space-y-2">
      <div className="text-sm">
        <span className="text-gray-600">New to Saarthi?</span>{' '}
        <Link
          to="/register" 
          className="inline-flex items-center font-semibold text-amber-600 hover:text-amber-800 transition-colors"
        >
          Create an account
          <svg 
            className="w-4 h-4 ml-1 transform transition-transform group-hover:translate-x-1" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </Link>
      </div>
    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;